<div class="app-layout d-flex">
  <div class="sidebar-container d-flex flex-column" [class.sidebar-collapsed]="isSidebarCollapsed">
    <!-- App Logo & Name -->
    <div class="sidebar-header text-center pt-3 mb-3">
      <button
        type="button"
        class="sidebar-toggle"
        (click)="toggleSidebar()"
        [attr.aria-label]="isSidebarCollapsed ? 'Developper le menu' : 'Reduire le menu'"
      >
        <i class="fa-solid" [class.fa-caret-left]="!isSidebarCollapsed" [class.fa-caret-right]="isSidebarCollapsed"></i>
      </button>
      <span class="nav-link d-flex align-items-center" routerLink="/dashboard">
        <div class="app-logo"></div>
        <h6 class="app-name mb-0 ms-2" [class.d-none]="isSidebarCollapsed">
          SODECOTON <br />
          Seed Expert
        </h6>
      </span>
    </div>
    <!-- Navigation -->
    <nav class="nav flex-column mb-3">
      <span
        class="nav-link d-flex align-items-center"
        routerLink="/dashboard"
        routerLinkActive="active"
      >
        <i class="fa-solid fa-gauge-high me-2"></i>
        <span class="nav-text" [class.d-none]="isSidebarCollapsed">Tableau de bord</span>
      </span>
      <span
        class="nav-link d-flex align-items-center"
        routerLink="/sites"
        routerLinkActive="active"
      >
        <i class="fa-solid fa-globe me-2"></i>
        <span class="nav-text" [class.d-none]="isSidebarCollapsed">Site</span>
      </span>
      <span
        class="nav-link d-flex align-items-center"
        routerLink="/varieties"
        routerLinkActive="active"
      >
        <i class="fa-solid fa-palette me-2"></i>
        <span class="nav-text" [class.d-none]="isSidebarCollapsed">Variete</span>
      </span>
      <span
        class="nav-link d-flex align-items-center"
        routerLink="/waves"
        routerLinkActive="active"
      >
        <i class="fa-solid fa-water me-2"></i>
        <span class="nav-text" [class.d-none]="isSidebarCollapsed">Vague</span>
      </span>
      <span
        class="nav-link d-flex align-items-center"
        routerLink="/productions"
        routerLinkActive="active"
      >
        <i class="fa-solid fa-industry me-2"></i>
        <span class="nav-text" [class.d-none]="isSidebarCollapsed">Production</span>
      </span>
      <span
        class="nav-link d-flex align-items-center"
        routerLink="/transfers"
        routerLinkActive="active"
      >
        <i class="fa-solid fa-right-left me-2"></i>
        <span class="nav-text" [class.d-none]="isSidebarCollapsed">Transfert</span>
      </span>
      <span
        class="nav-link d-flex align-items-center"
        routerLink="/delintages"
        routerLinkActive="active"
      >
        <i class="fa-solid fa-scissors me-2"></i>
        <span class="nav-text" [class.d-none]="isSidebarCollapsed">Delintage</span>
      </span>
      <span
        class="nav-link d-flex align-items-center"
        routerLink="/reports"
        routerLinkActive="active"
      >
        <i class="fa-solid fa-file-lines me-2"></i>
        <span class="nav-text" [class.d-none]="isSidebarCollapsed">Rapport</span>
      </span>
    </nav>

    <div class="sidebar-user-profile p-3 mt-auto mb-2" [class.profile-collapsed]="isSidebarCollapsed">
      <div class="d-flex align-items-center mb-2">
        <i class="fa-solid fa-circle-user fa-2x"></i>

        <div class="fw-bold ms-3 flex-grow-1 text-white fs-5" [class.d-none]="isSidebarCollapsed">
          {{ username | capitalize }}
        </div>
        <span
          [class.d-none]="isSidebarCollapsed"
          class="badge mx-2 border border-primary text-primary bg-transparent"
          >{{ userTitle || "external user" }}</span
        >
      </div>
      <button class="btn btn-primary btn-sm mt-2 w-100" (click)="logout()">
        <i class="fa-solid fa-arrow-right-from-bracket me-1"></i>
        <span [class.d-none]="isSidebarCollapsed">Logout</span>
      </button>
    </div>
  </div>
  <div class="main-content flex-grow-1 mx-4 mt-4">
    <router-outlet></router-outlet>
  </div>
</div>
